import React, { Component } from 'react';
import Axios from 'axios';
import { ROOT_URL } from '../../../actions';
import {PriceFormatter1 } from '../../../helper';
import { Card, Alert, CardDeck, Row, Col, ProgressBar, OverlayTrigger, Tooltip } from 'react-bootstrap';

function jsonToParam(param, startWith) {
    if (param) {
        let paramArr = [];
        Object.keys(param).forEach(function (key) {
            if (typeof param[key] != 'object')
                paramArr.push(encodeURIComponent(key) + '=' + encodeURIComponent(param[key]));
        });
        return startWith ? startWith + paramArr.join('&') : paramArr.join('&');
    } else {
        return '';
    }
}

function renderTooltip(text, props) {
    return (
        <Tooltip id="button-tooltip" {...props}>
            {text}
        </Tooltip>
    );
}

class MembershipQualification extends Component {

    constructor(props) {
        super(props);
        this.state = {
            params: {
                verifiedSource : false,
                buyingGroupId : 1,
            }
        }
    }

    static getDerivedStateFromProps(props, state) {
        let currentStateParams = state.params;
       // console.log('Existing state', props.params);
        currentStateParams = props.params;
        currentStateParams.verifiedSource = props.verifiedSource;
        return {
            params : currentStateParams
        };
    }

    // componentWillMount() {
    //     return this.props.buyingGroupId === 1;
    // }

    componentDidMount() {
        
        Axios.get(ROOT_URL + '/membership-qualification' + jsonToParam(this.state.params, '?'))
            .then(resp => this.setState({ qualification: resp.data }));
            
            
    }
    
    render() { 
        
        const { show } = this.props;
        if(this.state.params.buyingGroupId === "2"){
            return (
                ""
            // <Alert variant="primary" className="shadow-sm">Qualification Not Available</Alert>
            )
         }
        else {
        return (
            
            this.state.qualification ?
                <Card className="shadow-sm">
                    <Card.Body>
                        <Card.Title> <Row> <h4 style = {{marginLeft: "10px"}}> Membership Qualification - </h4> 
                        {this.state.qualification.map(level =>
                               <h4 style = {{marginTop:"0.5px", marginLeft: "2px"}}> {level.activeMembership === true  ?  level.membership :<span></span>}
                                    </h4> )} </Row></Card.Title>
                        
                        <Row>
                            
                            {this.state.qualification.map(level => <Col>
                                <h4 className="d-flex my-2">
                                    {level.membership}
                                    <span className="ml-auto">
                                        {level.qualified ? <React.Fragment>
                                                <span>Qualified</span> <i class="fas fa-check text-success"></i>
                                            </React.Fragment> : <React.Fragment>
                                                <i class="fas fa-times text-danger"></i>
                                            </React.Fragment>}
                                    </span>
                                </h4>
                                <div className="border p-2">
                                    <Row>
                                        {level.qualificationCriterias.map((criteria, index) => this.renderCriteria(criteria, index))}
                                    </Row>
                                </div>
                            </Col>)}
                        </Row>
                    </Card.Body>
                </Card> : ''
            
                // : <Alert variant="primary" className="shadow-sm">Qualification Not Available</Alert>
        )
                                        }
    }

    renderCriteria(criteria, index) {
        
        let width = 0;
        let variant = 'success';
        
        if (criteria.minVendorCount === 0) {
            width = criteria.actualPurchase / criteria.minPurchase * 100;
        } else {
            width = criteria.actualVendorCount / criteria.minVendorCount * 100;
        }
        
        width = width >= 100 ? 100 : width;
        
        if (width < 50) {
            variant = 'danger';
        } else if (width >= 50 && width < 100) {
            variant = 'warning';
        }

        return (
            <Col>
                <div>Criteria {index + 1}</div>
                <OverlayTrigger placement="bottom" overlay={props => renderTooltip(<strong>{
                    criteria.minVendorCount ? <React.Fragment>
                        <strong>Target: </strong>
                        {'Purchase of ' + PriceFormatter1(criteria.minPurchase) + ' from ' + criteria.minVendorCount + ' vendors '}
                        <br />
                        <strong>Actual: </strong>
                        {'Purchased ' + PriceFormatter1(criteria.minPurchase) + ' from ' + criteria.actualVendorCount + ' vendors'}
                    </React.Fragment> : <React.Fragment>
                        <strong>Target: </strong>
                        {'Purchase of ' + PriceFormatter1(criteria.minPurchase) + ' from all vendors'}
                        <br />
                        <strong>Actual: </strong>
                        {'Purchased of ' + PriceFormatter1(criteria.actualPurchase) + ' from all vendors'}
                    </React.Fragment>
                    }</strong>, props)}>
                    <ProgressBar now={width} variant={variant} />
                </OverlayTrigger>
            </Col>
        );
    }
}

export default MembershipQualification;
